// extracted by mini-css-extract-plugin
module.exports = {"thanks":"thank-you_thanks___r1lW"};